
import { defineComponent, reactive } from 'vue';
import route from '@/router';
import store, { MutationTypes } from '@/store';

import { decodeToken } from '@/utils/token';
import { post } from '@/utils/api';
import cookie from '@/utils/cookie';
import Button from '../components/Button.vue';
import InputField from '../components/InputField.vue';
import HeaderLinks from '../components/HeaderLinks.vue';

type LoginData = {
	email?: string;
	username?: string;
	password: string;
};

export default defineComponent({
	components: {
		Button,
		InputField,
		HeaderLinks,
	},

	setup() {
		const state = reactive({
			loginError: '',
			passwordError: '',
			error: '',

			inputData: {
				login: '',
				password: '',
			},

			loading: false,
		});

		const submit = async (event: Event) => {
			event.preventDefault();

			if (state.inputData.login == '') {
				state.loginError = 'Enter your username or email.';
			} else {
				state.loginError = '';
			}

			if (state.inputData.password == '') {
				state.passwordError = 'Enter your password.';
			} else {
				state.passwordError = '';
			}

			if (state.inputData.login != '' && state.inputData.password != '') {
				state.error = '';

				const loginData: LoginData = {
					username: state.inputData.login,
					email: state.inputData.login,
					password: state.inputData.password,
				};

				const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
				const isEmailAddress = emailRegex.test(String(state.inputData.login).toLowerCase());
				if (isEmailAddress) {
					delete loginData.username;
				} else {
					delete loginData.email;
				}

				const timeout = setTimeout(() => {
					state.loading = true;
				}, 1000);
				const data = await post('login', loginData);
				clearTimeout(timeout);
				state.loading = false;

				if (data.statusCode != 'OK') {
					if (data.statusCode == 'NON_EXISTING_USER') {
						state.loginError = 'This username or email does not exist.';
					} else if (data.statusCode == 'WRONG_PASSWORD') {
						state.passwordError = 'Wrong password.';
					}
				}

				if (data.error) {
					state.error = data.message;
					return;
				}

				const decodedToken = decodeToken(data.token);
				cookie.save('token', data.token, decodedToken.expirationDate);

				store.commit(MutationTypes.SET_USERID, data.userID);

				route.push('/home');
			} else {
				state.error = 'Fill in all the fields!';
			}
		};

		return {
			state,

			submit,
		};
	},
});
